export interface EmailVariantContent {
  title: string;
  subtitle: string;
  cta: string;
  microcopy: string;
}

export const emailVariants: Record<"A" | "B", EmailVariantContent> = {
  A: {
    title: "Ton profil est prêt 👀",
    subtitle: "On te l'envoie direct dans ta boîte.",
    cta: "Recevoir mon profil →",
    microcopy: "🔒 Zéro spam. Désinscription en 1 clic.",
  },
  B: {
    title: "On a trouvé ton profil investisseur 🎯",
    subtitle: "Entre ton email pour le découvrir — c'est cadeau.",
    cta: "Voir mon résultat →",
    microcopy: "Promis, pas de spam. Juste ton profil.",
  },
};

export type EmailVariantKey = keyof typeof emailVariants;
